import React from 'react';

import { BackdropSpinner } from '_lib/components/BackdropSpinner/BackdropSpinner';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';

type ScrollableContentWrapperProps = {
  children?: React.ReactNode;
  isSavingOrLoading?: boolean;
};

/** @deprecated - TODO: need to rethink this */
export const ScrollableContentWrapper = (props: ScrollableContentWrapperProps) => {
  const { children, isSavingOrLoading } = props;

  return (
    <FlexBox
      sx={(theme) => ({
        backgroundColor: theme.palette.background.default,
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        position: 'relative'
      })}>
      <BackdropSpinner open={typeof isSavingOrLoading === 'boolean' ? isSavingOrLoading : false} />
      <FlexBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          height: '100%',
          width: '100%'
        }}>
        {children}
      </FlexBox>
    </FlexBox>
  );
};
